/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { ReportStore } from './report-store';

export const ReportContext = React.createContext<ReportStore>({} as ReportStore);
